'use client'

import Backdrop from '@app/components/header/sections/desktop/search/backdrop/backdrop'
import {useSidebar} from '../sidebar-visiblity-context'
import {useScrollLock} from '@app/hooks/use-scroll-lock'
import s from './style.module.scss'

const SidebarBackdrop = () => {
  const {isOpen, closeSidebar} = useSidebar()
  const {lockScroll, unlockScroll} = useScrollLock()
  if (isOpen) {
    lockScroll()
  } else {
    unlockScroll()
  }
  return <Backdrop showBackdrop={isOpen} onClick={closeSidebar} className={s.z_index} />
}

export default SidebarBackdrop
